import { SimpleAutocomplete as SimpleAutocompleteBase } from './SimpleAutocomplete';
import { VirtualizedList } from './SimpleAutocompleteVirtualizedList';

export type { EmptyProps } from './SimpleAutocomplete';
export { useAutocompleteContext } from './SimpleAutocomplete';

export const SimpleAutocomplete = {
  ...SimpleAutocompleteBase,
  VirtualizedList,
};
